import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import useWindowSize from '../../customHooks/useWindowWidth';
import DropdownMenu from '../DropdownMenu';
import Button from '../../atoms/Button';
import { Body, Small } from '../../typography';
import { colors, fontSizes } from '../../../defaultTheme';
import query from '../../../const/mediaQueries';
import Grid from '../Grid';
import CLTooltip from '../../atoms/Tooltip';
import { SlideInModalPortal } from '../SlideInModalPortal';
const Tooltip = styled(CLTooltip) `
  width: 226px;
`;
export const ContentContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  padding: 0 16px;
  height: 100%;
  box-sizing: border-box;
  width: 100%;

  @media ${query.greaterThanLarge} {
    padding: 20px 10px;
  }

  @media ${query.lessThanMedium} {
    display: flex;
  }
`;
export const Logo = styled.img `
  height: 40px;

  @media ${query.greaterThanMedium} {
    height: 100%;
    max-height: 75px;
  }
`;
export const SecondaryLogo = styled(Logo) `
  max-width: 140px;
  height: 36px;

  @media ${query.greaterThanMedium} {
    max-width: 168px;
    height: 30px;
  }
  object-fit: contain;
`;
const commonButtonStyles = css `
  padding: 1rem;
  margin: 0;
  height: 40px;
  justify-content: center;

  &:hover {
    background-color: ${({ theme }) => theme.hoverBackground};
    text-decoration: none;
  }
`;
export const AccountButton = styled(Button) `
  margin: 0;
  padding: 0 0 0 0.5rem;
  height: 26px;

  &:hover {
    text-decoration: none;
  }

  @media ${query.greaterThanMedium} {
    padding: 0;
  }
`;
export const ProfileContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
`;
export const MobileSlideInModal = styled(SlideInModalPortal) `
  width: 80vw;
`;
export const ProfileContent = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${query.lessThanMedium} {
    justify-content: flex-end;
    height: 100%;
  }
`;
export const ProfileIconWrapper = styled.span `
  color: ${({ theme }) => theme.icon || colors.black};
  font-size: ${fontSizes.large}px;

  @media ${query.greaterThanSmall} {
    padding-right: 0.5rem;
  }
`;
export const ChevronIcon = styled.span `
  color: ${({ theme }) => theme.icon || colors.black};
  font-size: ${fontSizes.root}px;
`;
export const ModalHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 56px;
  background-color: ${({ theme }) => { var _a; return ((_a = theme.modal) === null || _a === void 0 ? void 0 : _a.headerBackground) || theme.headerBackground; }};
`;
export const AccountName = styled(Body) `
  color: ${({ theme }) => (theme.body ? theme.body.text : colors.black)};
  padding-right: 12px;
  padding-left: 15px;
  height: 40px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-transform: capitalize;
  ${({ language }) => language && `border-left: 1px solid ${colors.altoGrey};`}
`;
export const AccountModalName = styled(Body) `
  margin: 5px;
  text-transform: capitalize;
`;
export const ModalProfileButton = styled(Button) `
  height: 26px;
  padding: 0;
  margin: 0;
`;
export const ModalHeaderButton = styled(Button) `
  padding: 0;
  margin: 0;
`;
export const IconWrapper = styled.span `
  margin-right: 5px;
  color: ${({ theme }) => theme.icon};
`;
export const AccountDropdownMenu = styled(DropdownMenu) `
  ul {
    left: auto;
    right: 0;
  }
`;
export const NavigationList = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;
`;
export const ListItem = styled.li `
  padding: 0;
  margin: 0;
`;
export const ProfileIconWrapperModal = styled.span `
  padding-right: 16px;
`;
export const LanguageButtonWrapper = styled(Button) `
  ${commonButtonStyles}
  padding: 0px 20px;
  justify-content: flex-start;
  color: ${({ theme }) => theme.languageSelector};
  width: 100%;

  @media ${query.greaterThanMedium} {
    &:focus {
      outline: ${({ theme }) => theme.focus} auto 5px;
    }
  }
`;
export const AlertsButtonWrapper = styled(Button) `
  ${commonButtonStyles}
  font-size: 1.625rem;
  justify-content: center;
  padding: 0.5rem;
  border-right: 1px solid ${colors.altoGrey};

  @media ${query.greaterThanMedium} {
    padding: 20px;
    border-right: 0px;
  }
`;
export const BackButtonWrapper = styled(Button) `
  ${commonButtonStyles}
  height: 40px;
  padding: 0.5rem;

  @media ${query.greaterThanMedium} {
    padding: 1rem;
    border-left: 1px solid ${colors.altoGrey};
  }
`;
export const LeftContentContainer = styled.div `
  display: flex;
  align-items: center;
`;
export const LogoContainer = styled(Grid) `
  padding-right: 1rem;
`;
export const VerticalLine = styled.span `
  @media ${query.greaterThanMedium} {
    border-right: 1px solid ${colors.altoGrey};
    height: 40px;
    ${({ space }) => space && `margin-right: 15px;`};
  }
`;
export const AlertsButton = ({ handleAlertsClick, alertsIcon, alertsTooltip }) => {
    return alertsTooltip ? (_jsx(Tooltip, Object.assign({ isInteractive: true, id: "alerts-tooltip", placement: "bottom-end", content: _jsx(Body, { children: alertsTooltip }) }, { children: _jsx(AlertsButtonWrapper, Object.assign({ id: "alerts-button", ariaLabel: alertsTooltip, buttonType: "text", "data-icon": "bell", "data-object": "button", "data-reason": "manage alerts", "data-type": "manage alerts", "data-analytics": "clicktrackingevent", onClick: handleAlertsClick }, { children: _jsx(IconWrapper, { children: alertsIcon }) })) }))) : (_jsx(AlertsButtonWrapper, Object.assign({ id: "alerts-button", ariaLabel: "Manage alerts", buttonType: "text", "data-icon": "bell", "data-object": "button", "data-reason": "manage alerts", "data-type": "manage alerts", "data-analytics": "clicktrackingevent", onClick: handleAlertsClick }, { children: _jsx(IconWrapper, { children: alertsIcon }) })));
};
export const BackButton = ({ label, backIcon, handleBackButtonClick }) => {
    return (_jsxs(BackButtonWrapper, Object.assign({ id: "back-button", ariaLabel: "back to manage account", buttonType: "text", "data-object": "link", "data-reason": "back to manage account ", "data-type": "account summary", "data-analytics": "clicktrackingevent", onClick: handleBackButtonClick }, { children: [backIcon && _jsx(IconWrapper, { children: backIcon }), _jsx(Small, Object.assign({ weight: "semiBold" }, { children: label }))] })));
};
export const LanguageButton = ({ language, languageIcon, handleLanguageClick }) => {
    const windowWidth = useWindowSize();
    return (_jsxs(LanguageButtonWrapper, Object.assign({ id: "language-button", ariaLabel: `Change Language To ${language}`, buttonType: "text", "data-reason": language, "data-type": "customer menu", "data-analytics": "clicktrackingevent", onClick: handleLanguageClick }, { children: [languageIcon && _jsx(IconWrapper, { children: languageIcon }), _jsx(Body, Object.assign({ weight: windowWidth.isLessThanTablet ? 'regular' : 'bold' }, { children: language }))] })));
};
export const NavContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => { var _a; return ((_a = theme.systemNavigation) === null || _a === void 0 ? void 0 : _a.background) || theme.headerBackground; }};
  width: 100%;

  @media ${query.greaterThanLarge} {
    height: 80px;
  }

  @media ${query.betweenMediumLarge} {
    height: 56px;
  }

  @media ${query.lessThanMedium} {
    padding-top: 8px;
    display: inline-block;
    min-height: 56px;
  }
`;
